// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import NewFooterComponent from '../component/NewFooter';
// import Header from '../component/NewHeader';


// const JobEmployerGrid = () => {
//   const [employers, setEmployers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchEmployers = async () => {
//       try {
//         const response = await axios.get(`${process.env.REACT_APP_API_URL}jobrecruiter/allJobEmployer`);
//         setEmployers(response.data);
//       } catch (err) {
//         setError('Failed to fetch employer data. Please try again later.');
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchEmployers();
//   }, []);

//   if (loading) return <p className="text-center text-gray-600">Loading...</p>;
//   if (error) return <p className="text-center text-red-600">{error}</p>;

//   return (
//     <>
//     <Header/>
//   <div className="container mx-auto  mt-5  px-4 py-12">
//       <h2 className="text-2xl mt-3  text-3xl font-bold text-gray-800 mb-6 text-center">
//         Total Employers: {employers.length}
//       </h2>
//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
//         {employers.map((employer) => (
//           <div key={employer._id} className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300  text-orange-500">
//             <h3 className="text-xl text-orange-500  font-semibold text-gray-800 mb-2">{employer.companyName}</h3>
//             <p className="text-gray-600 mb-1"><strong>Email:</strong> {employer.email}</p>

//             <p className="text-gray-600 mb-1"><strong>Size:</strong> {employer.size}</p>
//             <p className="text-gray-600 mb-1"><strong>Address:</strong> {employer.address}</p>
//             <p className="text-gray-600 mb-1"><strong>State:</strong> {employer.state}</p>
//             <p className="text-gray-600"><strong>Local Government:</strong> {employer.localGovernment}</p>
//           </div>
//         ))}
//       </div>
//     </div>
//     <NewFooterComponent/>
//     </>
  
//   );
// };

// export default JobEmployerGrid;



import React, { useState, useEffect } from 'react';
import axios from 'axios';
import NewFooterComponent from '../component/NewFooter';
import Header from '../component/NewHeader';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa'; // Icons

const JobEmployerGrid = () => {
  const [employers, setEmployers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch employers
  useEffect(() => {
    const fetchEmployers = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}jobrecruiter/allJobEmployer`);
        setEmployers(response.data);
      } catch (err) {
        setError('Failed to fetch employer data. Please try again later.');
      } finally {
        setLoading(false);
      }
    };
    fetchEmployers();
  }, []);

  // Count logic
  const locationApprovedCount = employers.filter(emp => emp.addressVerified).length;
  const businessApprovedCount = employers.filter(emp => emp.businessVerified).length;
  const bothApprovedCount = employers.filter(emp => emp.addressVerified && emp.businessVerified).length;

  if (loading) return <p className="text-center text-gray-600">Loading...</p>;
  if (error) return <p className="text-center text-red-600">{error}</p>;

  return (
    <>
      <Header />
      <div className="container mx-auto mt-10 px-4 py-12">
        <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center">
          Total Employers: {employers.length}
        </h2>

        {/* Stats */}
        <div className="mb-8 text-center text-lg text-gray-700 space-y-1">
          <p><strong>📍 Location Approved:</strong> {locationApprovedCount}</p>
          <p><strong>🏢 Business Approved:</strong> {businessApprovedCount}</p>
          <p><strong>✅ Both Approved:</strong> {bothApprovedCount}</p>
        </div>

        {/* Employers Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {employers.map((employer) => (
            <div
              key={employer._id}
              className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 border border-orange-200"
            >
              <h3 className="text-xl text-orange-500 font-semibold mb-2">{employer.companyName}</h3>
              <p className="text-gray-600 mb-1"><strong>Email:</strong> {employer.email}</p>
              <p className="text-gray-600 mb-1"><strong>Size:</strong> {employer.size}</p>
              <p className="text-gray-600 mb-1"><strong>Address:</strong> {employer.address}</p>
              <p className="text-gray-600 mb-1"><strong>State:</strong> {employer.state}</p>
              <p className="text-gray-600 mb-3"><strong>LGA:</strong> {employer.localGovernment}</p>

              {/* Approval Status */}
              <div className="mt-4">
                <p className="flex items-center gap-2 text-sm">
                  <strong>📍 Location Verified:</strong>
                  {employer.addressVerified ? (
                    <FaCheckCircle className="text-green-500" />
                  ) : (
                    <FaTimesCircle className="text-red-500" />
                  )}
                </p>
                <p className="flex items-center gap-2 text-sm mt-1">
                  <strong>🏢 Business Verified:</strong>
                  {employer.businessVerified ? (
                    <FaCheckCircle className="text-green-500" />
                  ) : (
                    <FaTimesCircle className="text-red-500" />
                  )}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <NewFooterComponent />
    </>
  );
};

export default JobEmployerGrid;
